import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Apply from "@/pages/Apply";
import Categories from "@/pages/Categories";
import CategoryDetail from "@/pages/CategoryDetail";
import QuestionDetail from "@/pages/QuestionDetail";
import MockExam from "@/pages/MockExam";
import ExamResults from "@/pages/ExamResults";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminUserDetail from "@/pages/admin/AdminUserDetail";
import AdminQuestions from "@/pages/admin/AdminQuestions";
import AdminQuestionNew from "@/pages/admin/AdminQuestionNew";
import AdminQuestionEdit from "@/pages/admin/AdminQuestionEdit";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminAttempts from "@/pages/admin/AdminAttempts";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminApplications from "@/pages/admin/AdminApplications";
import AdminContent from "@/pages/admin/AdminContent";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/categories" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Navigate to="/apply" replace />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/categories" element={<Protected><Categories /></Protected>} />
            <Route path="/categories/:code" element={<Protected><CategoryDetail /></Protected>} />
            <Route path="/questions/:qid" element={<Protected><QuestionDetail /></Protected>} />
            <Route path="/mock-exam/:attemptId" element={<Protected><MockExam /></Protected>} />
            <Route path="/exam-results/:attemptId" element={<Protected><ExamResults /></Protected>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin" element={<AdminOnly><AdminDashboard /></AdminOnly>} />
            <Route path="/admin/seed" element={<AdminOnly><Admin /></AdminOnly>} />
            <Route path="/admin/applications" element={<AdminOnly><AdminApplications /></AdminOnly>} />
            <Route path="/admin/users" element={<AdminOnly><AdminUsers /></AdminOnly>} />
            <Route path="/admin/users/:uid" element={<AdminOnly><AdminUserDetail /></AdminOnly>} />
            <Route path="/admin/questions" element={<AdminOnly><AdminQuestions /></AdminOnly>} />
            <Route path="/admin/questions/new" element={<AdminOnly><AdminQuestionNew /></AdminOnly>} />
            <Route path="/admin/questions/:qid" element={<AdminOnly><AdminQuestionEdit /></AdminOnly>} />
            <Route path="/admin/categories" element={<AdminOnly><AdminCategories /></AdminOnly>} />
            <Route path="/admin/attempts" element={<AdminOnly><AdminAttempts /></AdminOnly>} />
            <Route path="/admin/analytics" element={<AdminOnly><AdminAnalytics /></AdminOnly>} />
            <Route path="/admin/content" element={<AdminOnly><AdminContent /></AdminOnly>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
